import { unref, computed } from '@vue/composition-api'
import { getMatchDetailLink } from '@ms/routes/match'

// 比赛链接
export default function useMatchLink(event) {
  const matchLink = computed(() => getMatchDetailLink(unref(event)))
  return matchLink
}
